export enum ScreenResult {
  MEETS_EXPECTATIONS = 'Meets Expectations',
  NEEDS_REVIEW = 'Needs Review',
}
